__turbopack_context__.v({
  "container": "NIjTfG_container",
  "dropzone": "NIjTfG_dropzone",
  "file": "NIjTfG_file",
  "file-size": "NIjTfG_file-size",
  "files": "NIjTfG_files",
  "size": "NIjTfG_size",
});
